import _ from 'underscore';

angular.module('am4')
.directive('elasticListColumn', function($filter, $translate, $timeout, REGEX) {
    return {
        restrict: 'E',
        scope: {
            columnType: '=',
            columnName: '=',
            columnElements: '=',
            checkedInColumn: '=',
            selectionCallback: '=',
            elementLookup: '=',
            cyName: '='
        },
        template: require('./elasticListColumn.html'),
        link: function(scope, element) {

            // Convert machine_type_code to CMS translation key
            function toCmsKey(val) {
                return val ? val.toUpperCase().replaceAll(' ', '_') : '';
            }

            // Deduplication maps for machine_type_code (CMS key → [raw codes])
            var cmsKeyToRawCodes = {},
                dedupElements = null;

            function rebuildDedupMaps(elements) {
                cmsKeyToRawCodes = {};
                _.each(elements, function(val) {
                    var key = toCmsKey(val);
                    if (!cmsKeyToRawCodes[key]) {
                        cmsKeyToRawCodes[key] = [];
                    }
                    cmsKeyToRawCodes[key].push(val);
                });
            }

            function deduplicateByLabel(elements) {
                var seen = {};
                return _.filter(elements, function(val) {
                    var key = toCmsKey(val);
                    if (seen[key]) {
                        return false;
                    }
                    seen[key] = true;
                    return true;
                });
            }

            function getBaseElements() {
                if (scope.columnType === 'machine_type_code' && dedupElements) {
                    return dedupElements;
                }
                return scope.columnElements;
            }

            scope.$watch('columnElements', function(newVal) {
                if (scope.columnType === 'machine_type_code' && newVal) {
                    rebuildDedupMaps(newVal);
                    dedupElements = deduplicateByLabel(newVal);
                }

                if (scope.search.active) {
                    filterElements();
                } else {
                    scope.displayElements = getBaseElements();
                }
            });

            scope.search = {
                active: false,
                searchTerm: ''
            };

            scope.getText = function(val) {
                switch (scope.columnType) {
                case 'organization_id': return scope.elementLookup[val] || $translate.instant('UNKNOWN');
                case 'facility_id': return scope.elementLookup[val] || $translate.instant('UNKNOWN');
                case 'machine_type_code': return $translate.instant(toCmsKey(val)) || $translate.instant('UNKNOWN');
                case 'series': return $filter('seriesName')(val) || $translate.instant('UNKNOWN');
                case 'status': return $translate.instant(val);
                default: return $translate.instant('UNKNOWN');
                }
            };

            // Check if an item is selected, accounting for machine_type_code variant deduplication
            scope.isItemChecked = function(elem) {
                if (scope.columnType === 'machine_type_code') {
                    var key = toCmsKey(elem),
                        variants = cmsKeyToRawCodes[key] || [elem];
                    return _.some(variants, function(v) {
                        return scope.checkedInColumn[v];
                    });
                }
                return scope.checkedInColumn[elem];
            };

            // Handle click, expanding machine_type_code clicks to all case variants
            scope.handleClick = function(elem, columnType) {
                if (columnType === 'machine_type_code') {
                    var key = toCmsKey(elem),
                        variants = cmsKeyToRawCodes[key] || [elem],
                        anyChecked = _.some(variants, function(v) {
                            return scope.checkedInColumn[v];
                        });

                    _.each(variants, function(code) {
                        var codeChecked = !!scope.checkedInColumn[code];
                        // Unchecking: toggle checked variants; Checking: toggle unchecked variants
                        if (anyChecked === codeChecked) {
                            scope.selectionCallback(code, columnType);
                        }
                    });
                } else {
                    scope.selectionCallback(elem, columnType);
                }
            };

            scope.getSearchTerm = function(val) {
                if (scope.columnType === 'organization_id' || scope.columnType === 'facility_id') {
                    return (scope.elementLookup[val] + ' ' + val) || $translate.instant('UNKNOWN');
                }
                return scope.getText(val);

            };

            // All of this madness is due to safari mobile (iOS)
            // requiring element.focus() to be triggered in a touchstart event
            element.find('.am4-filters__header').on('touchstart click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                scope.search.active = !scope.search.active;

                if (scope.search.active) {
                    element.find('input')[0].focus();
                } else {
                    element.find('input')[0].blur();
                    // delete search when deactivating search state
                    scope.search.searchTerm = '';
                    constructRegex();
                    filterElements();
                }

                scope.$apply();
            });

            element.find('input').on('touchstart click', function(e) {
                e.stopPropagation();
            });

            scope.$watch('search.searchTerm', function() {
                constructRegex();
                filterElements();
            });

            function constructRegex() {
                scope.search.searchRegex = new RegExp(scope.search.searchTerm
                    .replace(REGEX.REGEX_CHARACTERS, '\\$&')
                    .split(REGEX.SPACES)
                    .join('.*'), 'i');
            }

            function filterElements() {
                scope.displayElements = _.filter(getBaseElements(), function(val) {
                    return scope.search.searchRegex.test(scope.getSearchTerm(val));
                });
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/elasticListColumn.js